import { render, staticRenderFns } from "./CardChartPie.vue?vue&type=template&id=f51bb57c&"
import script from "./CardChartPie.vue?vue&type=script&lang=js&"
export * from "./CardChartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports